import React from "react"
import { Alert } from "../../../components/alert"
import { Flex, Text } from "../../../vanilla"
import { useBasketStore, useRapidDeliveryStore } from "../../../store/hooks/useStore"

export const UnavailableCartItemAlert = () => { 
  const {previouslyRemovedItems} = useBasketStore()
  const {isRapidDeliveryBooked} = useRapidDeliveryStore()
  return (
    <Alert status="warning" align="flex-start" data-test-selector="unavailable-cart-item-alert">
        <Flex flexDirection="column">
            <Text variant="text3Bold" data-test-selector="unavailable-cart-item-alert-title">{previouslyRemovedItems.length} {previouslyRemovedItems.length > 1 ? 'items in your basket are not available' : 'item in your basket is not available'} for {isRapidDeliveryBooked ? 'Rapid Delivery' : 'Delivery'}</Text>
            <Text variant="text3" data-test-selector="unavailable-cart-item-alert-text">You can view alternative items or remove them. They will be automatically removed when you checkout.</Text>
        </Flex>
    </Alert>
)
}